<script lang="ts">
	import { object, string, type InferType } from 'yup';
	import { Auth, API } from 'aws-amplify';
	import { createForm } from 'felte';
	import { validator } from '@felte/validator-yup';
	import CustomInput from '../CustomInputs/CustomInput.svelte';
	import { createEventDispatcher } from 'svelte';
	import FormInput from '../CustomInputs/FormInput.svelte';
	import { GRAPHQL_AUTH_MODE, type GraphQLQuery } from '@aws-amplify/api';

	const dispatch = createEventDispatcher<{
		closeForgotPassword: void;
		closeRegister: void;
	}>();

	let showChangePassword: boolean = false;
	let email: string = '';
	let errorMessage: string = '';

	const schema = object({
		password: string().required('Password is required.'),
		// match with password field
		confirmPassword: string()
			.min(6, 'Password must be at least 6 characters.')
			.required('Confirm password is required.')
			.test('match', 'Password not match.', function (value) {
				return value === this.parent.password;
			}),
		emailCode: string().required('Code is required.')
	});

	type Schema = InferType<typeof schema>;

		const { form, errors, data, isSubmitting, setFields } = createForm<Schema>({
		extend: validator({ schema }),
		initialValues: {
			password: '',
			confirmPassword: '',
			emailCode: ''
		},
		onSubmit: async (values) => {
			errorMessage = ''
			// Collect confirmation code and new password
			try {
				const data = await Auth.forgotPasswordSubmit(
					email.toLocaleLowerCase(),
					values.emailCode,
					values.password
				);
				console.log(data);
			} catch (err: any) {
				errorMessage = 'Invalid verification code provided, please try again';
				return;
			}
			dispatch('closeForgotPassword');
		}
	});

	const sendEmailCode = async (email: string) => {
		errorMessage = '';
		try {
			const data = await Auth.forgotPassword(email.toLocaleLowerCase());

			const pgUsers = await API.graphql<GraphQLQuery<any>>({
				query: /* GraphQL */ `
					query AllPgUsers($filter: PgUserFilter) {
						allPgUsers(filter: $filter) {
							nodes {
								id
								email
							}
						}
					}
				`,
				variables: { filter: { email: { _eq: email } } },
				authMode: GRAPHQL_AUTH_MODE.API_KEY
			});

			if(!pgUsers.data.allPgUsers.nodes.length) {
				errorMessage = 'User does not exist. Register, please, for any class or event.'
				return;
			}
			errorMessage = '';
			showChangePassword = !showChangePassword;
		} catch (err: any) {
			if (err.message === 'Username cannot be empty') {
				errorMessage = 'Enter your email';
			}
			console.log('Enter your email');
			return;
		}
	};
</script>

<form class="flex flex-col gap-2" use:form>
	{#if !showChangePassword}
		<h2 class="text-xl font-jakarta-bold text-shark text-center">Forgot Password</h2>
		<CustomInput
			bind:value={email}
			on:input={(e) => ((email = e.detail), (errorMessage = ''))}
			label={'Email Address'}
			placeholder={''}
		/>
		<button
			type="button"
			on:click={(event) => (dispatch('closeForgotPassword'), event.stopPropagation())}
			class="text-sm text-affair cursor-pointer"
		>
			Sign in
		</button>
		<div class="flex justify-center">
			<button
				on:click={() => sendEmailCode(email)}
				type="button"
				class="register-btn !bg-affair w-full"
			>
				Send
			</button>
		</div>
		{#if errorMessage}
			<span class="text-red text-sm">{errorMessage}</span>
		{/if}
	{:else}
		<h2 class="text-xl font-jakarta-bold text-shark text-center">Reset Password</h2>
		<CustomInput
			bind:value={$data.emailCode}
			on:input={(e) => setFields('emailCode', e.detail)}
			label={'Enter code from email'}
			placeholder={''}
		/>
		{#if $errors.emailCode}
			<span class="text-red text-sm">{$errors.emailCode.toString()}</span>
		{/if}
		<FormInput
			label={'Password*'}
			placeholder={''}
			bind:value={$data.password}
			felteErrors={$errors}
			felteProp="password"
			autocomplete="new-password"
		/>
		<FormInput
			label={'Confirm password*'}
			placeholder={''}
			bind:value={$data.confirmPassword}
			felteErrors={$errors}
			felteProp="confirmPassword"
			autocomplete="new-password"
		/>
		<div class="flex justify-center">
			<button disabled={$isSubmitting} type="submit" class="register-btn !bg-affair w-full">
				{#if $isSubmitting}
					Please wait ...
				{:else}
					Reset Password
				{/if}
			</button>
		</div>
		{#if errorMessage}
			<span class="text-red text-sm">{errorMessage}</span>
		{/if}
	{/if}
</form>
